
export default context => {
    $('textarea.fixed', context).on('keydown', function(e) {
        this.value = this.value.replace(/\n/g, ' ')
        if ( e.which === 13 ) {
            e.preventDefault();
        }
    })
}
